export default __webpack_public_path__ + "static/media/colorRocks.7377505e.jpg";